import type { Currency } from "@loot-os/api-contract";
import { BoxCard } from "@loot-os/ui/components/box-card";
import { Button } from "@loot-os/ui/components/button";
import { ButtonGroup } from "@loot-os/ui/components/button-group";
import { cn } from "@loot-os/ui/lib/utils";
import { Link } from "@tanstack/react-router";
import { HeartIcon } from "lucide-react";

import type { BoxTile } from "../pages/shared/boxTiles.js";

/**
 * The design's Box-Card: the card links to the box, and the heart in its corner is a sibling of
 * that link rather than inside it, so it stays a control of its own.
 */
export function ClassicBoxTile({
  tile,
  currency,
  className,
}: {
  tile: BoxTile;
  currency: Currency;
  className?: string;
}) {
  const { box, favorite } = tile;
  return (
    <div className={cn("relative h-full", className)}>
      <Link to="/boxes/$boxId" params={{ boxId: box.id }} className="block h-full">
        <BoxCard box={box} currency={currency} />
      </Link>
      <ButtonGroup className="absolute top-2.5 right-2.5">
        <Button
          variant="outline"
          size="icon-sm"
          aria-label={favorite.label}
          aria-pressed={favorite.saved}
          onClick={favorite.onToggle}
        >
          <HeartIcon className={favorite.saved ? "fill-primary text-primary" : undefined} />
        </Button>
      </ButtonGroup>
    </div>
  );
}
